import { NumberInput } from '@payaca/ambrosia';
import { FC } from 'react';
import { FieldProps } from './fieldInputTypes';

export const NumberFieldInput: FC<FieldProps<'number'>> = (props) => {
  const { value, onChange } = props;

  return <NumberInput value={value ?? null} onChange={onChange} />;
};
